import { useTranslation } from "react-i18next";
import { resendValidateEmail } from "../../api/Services";

import { Button, message, Typography, Spin } from "antd";
import { MailOutlined, LoadingOutlined } from "@ant-design/icons";

import styles from "./CheckEmail.module.scss";
import { useState } from "react";

const CheckEmail = ({ organizationName, email }: any) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const sendEmailAgain = async () => {
    setLoading(true);
    const response = await resendValidateEmail(email, organizationName);
    if (response) message.success(t("CheckEmail-SendSuccesMessage"));
    else message.error(t("CheckEmail-SendErrorMessage"));
    setLoading(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconWrapper}>
          <MailOutlined className={styles.icon} />
        </div>
        
        <div className={styles.content}>
          <Typography.Title level={2} className={styles.title}>
            {t("CheckEmail-Title")}
          </Typography.Title>
          
          <Typography.Text className={styles.description}>
            {t("CheckEmail-Description", { email })}
          </Typography.Text>
          
          <Button
            className={styles.button}
            onClick={sendEmailAgain}
            type="primary"
            htmlType="button"
            disabled={loading}
            size="large"
            block
          >
            {loading ? (
              <Spin
                indicator={<LoadingOutlined className="ol-loading-spin-icon" />}
                delay={500}
              />
            ) : (
              t("CheckEmail-SendAgain")
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckEmail;
